import './Services.css';
import './ServiceDetails.css';
import './HomePreview.css';
import { servicesData } from '../data/servicesData';

// The 5 core service lines shown on the homepage — the granular sub-services
// (SEO, Google Ads, Meta Ads, Social Media Management, Shopify eCommerce)
// live inside their parent's detail page and the full /services explorer.
const coreSlugs = [
  'website-development',
  'digital-marketing',
  'graphic-design',
  'ai-solutions',
  'custom-software-development',
];

// Home page preview — zhar-style "What We Do" index alongside a supporting
// visual: list + outcome line on one side, image on the other.
export default function ServicesPreview() {
  const items = coreSlugs.map(slug => servicesData.find(s => s.slug === slug)).filter(Boolean);

  return (
    <section id="services-preview" className="services-section">
      <div className="services-header reveal">
        <span className="section-label">What We Do</span>
        <h2 className="section-title">Full-stack digital growth. <em>Every layer covered.</em></h2>
        <p className="section-sub">From storefront to storefeed, from first click to last mile — one team, one timeline, one accountable partner.</p>
      </div>

      <div className="sd-row">
        <div className="svc-index reveal-left">
          {items.map((s, i) => (
            <a key={s.slug} href={`#/services/${s.slug}`} className="svc-index-row">
              <span className="svc-index-num">{String(i + 1).padStart(2, '0')}</span>
              <div className="svc-index-text">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
              <span className="svc-index-arrow">→</span>
            </a>
          ))}
        </div>
        <div className="sd-img reveal-right">
          <img src="/images/what-we-do.jpg" alt="AerialRoot — full-stack digital growth" loading="lazy" />
        </div>
      </div>

      <div className="home-more reveal">
        <a href="#/services" className="btn-ghost">View All Services →</a>
      </div>
    </section>
  );
}
